import { computed, Injectable, signal } from '@angular/core';
import { CartItem, Product } from '../models/product.model';
@Injectable({providedIn:'root'})
export class CartService {
  readonly items = signal<CartItem[]>([]);
  readonly count = computed(() => this.items().reduce((n,item)=>n+item.quantity,0));
  readonly subtotal = computed(() => this.items().reduce((n,item)=>n+item.product.price*item.quantity,0));
  add(product: Product) { this.items.update(items => { const current=items.find(i=>i.product.id===product.id); return current ? items.map(i=>i.product.id===product.id?{...i,quantity:i.quantity+1}:i) : [...items,{product,quantity:1}]; }); }
  changeQuantity(id:number,delta:number){this.items.update(items => items.map(i=>i.product.id===id?{...i,quantity:i.quantity+delta}:i).filter(i=>i.quantity>0));}
  clear(){this.items.set([]);}
}
